import { makeRequest } from 'utils/requestLogger';

// This endpoint deletes a student submission and denies them access to the Roudntable.
// Student is kicked out
export default (roundtableId, userId) =>
  makeRequest(
    'delete',
    `/api/roundtables/${roundtableId}/remove-student/${userId}`
  );



// WEBPACK FOOTER //
// ./src/app/features/onlineRoundtables/services/roundtable/removeStudent.js